import { t } from '@web-solutions/module-localization';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import styles from '../../styles/style.module.scss';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import { renderHighlightedTitle } from 'src/onboarding/helpers/renderHighlightedTitle';
import getLocale from 'src/localization/get-locale';

export const ReportComponent = () => {
  const { report } = useRemoteConfig();
  const locale = getLocale();

  return (
    <div className={styles.metabolismContainer}>
      <Title tag='h4'>{renderHighlightedTitle(report.title[locale])}</Title>

      <div className={styles.featuresGrid}>
        {report.options.map((option, index) => (
          <div key={index} className={styles.featureCard}>
            <span className={styles.featureIcon}>{option.emoji}</span>
            <div className={styles.featureContent}>
              <Text size='l' semibold className={styles.featureTitle}>
                {option.title[locale]}
              </Text>
              <Caption size='l' className={styles.featureDescription}>
                {option.subTitle[locale]}
              </Caption>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
